import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
import { Mail } from "lucide-react";

const TABS = [
  { to: "/dashboard/admin/comms/email-automations", label: "Overview", exact: true },
  { to: "/dashboard/admin/comms/email-automations/upgrade", label: "Provider Upgrade Sequence" },
];

export const Route = createFileRoute("/dashboard/admin/comms/email-automations")({
  head: () => ({ meta: [{ title: "Email Automations · Admin" }, { name: "robots", content: "noindex" }] }),
  component: Layout,
});

function Layout() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  const onIndex = path === "/dashboard/admin/comms/email-automations";

  return (
    <div className="px-6 py-4 space-y-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Mail className="h-4 w-4 text-muted-foreground" />
          <h2 className="text-[18px] font-semibold tracking-tight">Email Automations</h2>
        </div>
      </div>

      <div className="border-b border-border overflow-x-auto">
        <nav className="flex items-center gap-1 min-w-max">
          {TABS.map((t) => {
            const active = t.exact ? path === t.to : path === t.to || path.startsWith(t.to + "/");
            return (
              <Link
                key={t.to}
                to={t.to}
                className={cn(
                  "relative px-3 py-2 text-[12.5px] transition-colors whitespace-nowrap -mb-px",
                  active
                    ? "text-primary font-semibold"
                    : "text-muted-foreground hover:text-foreground font-medium",
                )}
              >
                {t.label}
                {active && <span className="absolute left-2 right-2 -bottom-px h-[2px] bg-primary rounded-full" />}
              </Link>
            );
          })}
        </nav>
      </div>

      {onIndex ? (
        <div className="rounded-md border border-border bg-card p-6">
          <h3 className="text-[14px] font-semibold mb-2">Automated email sequences</h3>
          <p className="text-[13px] text-muted-foreground mb-4">
            Send the right email at the right time, automatically. Start with the
            Provider Upgrade Sequence — a 7-step drip that helps free providers
            understand the value of Premium without being pushy.
          </p>
          <Link
            to="/dashboard/admin/comms/email-automations/upgrade"
            className="inline-flex items-center text-[13px] font-medium text-primary"
          >
            Open Provider Upgrade Sequence →
          </Link>
        </div>
      ) : (
        <Outlet />
      )}
    </div>
  );
}
